export default "__VITE_ASSET__DrGJLScb__"